// import { ApolloNextAppProvider } from '@apollo/experimental-nextjs-app-support';
import { ApolloProvider as Apollo } from '@apollo/client';
import { useMemo } from 'react';

import { KaktuApolloClientOptions, createApolloClient } from '../../api/apollo/index';

export function ApolloProvider({
  children,
  ...options
}: React.PropsWithChildren<KaktuApolloClientOptions>) {
  const client = useMemo(
    () => createApolloClient(options),
    [
      options.auth,
      options.graphqlUrl,
      options.headers,
      options.fetchPolicy,
      options.connectToDevTools,
      options.cache,
      options.onError,
      options.link,
      options.generateLinks,
    ],
  );

  return (
    <Apollo client={client}>
      {children}
    </Apollo>
  );
}
